import { Order, Shop } from "../../types";
import ShopService from "../services/shop-service";

let factory = {
    getDefaultSaleAreaId,
    getSaleAreasFor,
	validateSaleAreaId,
    CLICK_COLLECT: "CLICK_COLLECT",
    DELIVERY: ShopService.SALE_AREAS.DELIVERY,
    TO_STAY: ShopService.SALE_AREAS.TO_STAY,
    TO_GO: ShopService.SALE_AREAS.TO_GO,
};

export default factory;


function has(order: Order, SaleAreaId) {
    let saleAreas = getSaleAreasFor(order);
	if (SaleAreaId == factory.CLICK_COLLECT) {
		return saleAreas[ShopService.SALE_AREAS.TO_GO] || saleAreas[ShopService.SALE_AREAS.TO_STAY];
	}
	return saleAreas[SaleAreaId];
}

function getSaleAreasFor(order: Order) {
	let shop = order.shop;
	let arr = shop.sale_areas;
	// dont add the sister shops sale_areas
	// for (let i in shop.sister_shops) {
	// 	arr = arr.concat(shop.sister_shops[i].sale_areas);
	// }
	let saleAreas = {};
	for (let j in arr) {
		let area = arr[j];
		if (area.pivot.ModeId == order.SaleModeId && !saleAreas[area.SaleAreaId]) {
			saleAreas[area.SaleAreaId] = area;
		}
	}
	// ensure salon has "A Table" sale mode
	if (shop.info.salon?.active) {
		if (!saleAreas[ShopService.SALE_AREAS.RESTAURANT]) {
			saleAreas[ShopService.SALE_AREAS.RESTAURANT] = {
				DefaultName: 'Restaurant',
				SaleAreaId: ShopService.SALE_AREAS.RESTAURANT,
			};
		}
	}
	saleAreas[ShopService.SALE_AREAS.TICKET] = {
		DefaultName: 'Ticket',
		SaleAreaId: ShopService.SALE_AREAS.TICKET,
	};
	return saleAreas;
}

function validateSaleAreaId(order: Order) {
	let saleAreas = getSaleAreasFor(order);
	// (in)validate current SaleAreaId
	if (!saleAreas[order.SaleAreaId]) {
		order.SaleAreaId = null;
	}
	// set SaleAreaId from default state
	if (!order.SaleAreaId) {
        order.SaleAreaId = getDefaultSaleAreaId(order);
	}
}

function getDefaultSaleAreaId(order: Order) {
    let SaleAreaId = has(order, order.shop.info.defaultSaleAreaId) ? order.shop.info.defaultSaleAreaId : 0;
    if (SaleAreaId == ShopService.SALE_AREAS.DELIVERY || !has(order, factory.CLICK_COLLECT)) {
        return ShopService.SALE_AREAS.DELIVERY;
    } else {
        if (has(order, ShopService.SALE_AREAS.TO_GO)) {
            return ShopService.SALE_AREAS.TO_GO;
        } else {
            return ShopService.SALE_AREAS.TO_STAY;
        }
    }
}